export default (props, vars) =>
  vars?.['useapplicationoffer2']?.['applicationOffer']
    .acceptance_image_for_social_media_url;
